"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectToStep = void 0;
var react_use_1 = require("react-use");
var core_1 = require("../core");
var RedirectToStep = function (_a) {
    var stepId = _a.stepId;
    var goToStep = (0, core_1.useWizardStepNavigate)();
    (0, react_use_1.useMount)(function () {
        goToStep(stepId, true);
    });
    return null;
};
exports.RedirectToStep = RedirectToStep;
//# sourceMappingURL=RedirectToStep.js.map